export default "__VITE_ASSET__zpf_PLVKUDh5mGiUOwFSfA__"